const updaters = [];

export function register(fn) {
	updaters.push(fn);
}

export function unregister(fn) {
	const i = updaters.indexOf(fn);
	if (i > -1) updaters.splice(i, 1);
}

export function triggerAll() {
	updaters.forEach((fn) => {
		try {
			fn();
		} catch (e) {
			console.warn("Chart view update failed:", e);
		}
	});
}
